import React from "react";
import { Modal } from "antd";
import { FormInstance } from "antd/lib/form";
import { TTranslate } from "../../../service/locale/TranslationService";
import moment from "moment";

const FormComponent = ({ Form, rowData }) => {
  return React.cloneElement(Form, {
    rowData: { ...rowData }
  });
};

const formatRowData = (rowData: any) => {
  let data: any = rowData;
  Object.keys(rowData || {}).forEach((key) => {
    if (rowData[key] instanceof Date) {
      data[key] = rowData[key] ? moment(rowData[key]) : undefined;
    }
  });
  return data;
};

const UpdateModal = ({
  translate,
  title,
  visible,
  onUpdate,
  onCancel,
  Form,
  formInstance,
  rowData,
  className
}: {
  translate: TTranslate;
  title?: string;
  visible: boolean;
  onUpdate: any;
  onCancel: any;
  Form: any;
  formInstance?: FormInstance;
  rowData: any;
  className: string;
}) => {
  const data = formatRowData(rowData);
  //formInstance?.setFieldsValue(data);
  return (
    <Modal
      visible={visible}
      title={title}
      okText={translate("data_grid.modal.actions.save")}
      cancelText={translate("data_grid.modal.actions.cancel")}
      onCancel={() => {
        formInstance?.resetFields();
        onCancel();
      }}
      maskClosable={false}
      onOk={() => {
        formInstance
          ?.validateFields()
          .then(async (values) => {
            await onUpdate(values).then((res) => {
              formInstance.resetFields();
              onCancel();
            });
          })
          .catch(console.log);
      }}
      className={"modal-position " + className}
    >
      <FormComponent Form={Form} rowData={data} />
    </Modal>
  );
};

export default UpdateModal;
